import { KPI_COLS } from './dashboardWidgetPresets';

export const CUSTOM_DASHBOARD_TEMPLATE_ID = 'template_custom';
export const STANDARD_DASHBOARD_TEMPLATE_ID = 'template_standard';

const KPI_ROW = {
  id: 'kpi_row',
  rowType: 'kpi',
  layout: 'kpi-grid',
  cols: KPI_COLS(4),
};

const TRENDS_ROW = {
  id: 'trends_row',
  rowType: 'chart',
  cols: [
    {
      id: 'trends',
      col: 'col-12',
      slotKey: 'trends',
      slotType: 'chart',
      variant: 'tall',
    },
  ],
};

const DISTRIBUTION_ROW = {
  id: 'distribution_row',
  rowType: 'chart',
  layout: 'chart-grid',
  cols: [
    { id: 'status', col: 'col-6', slotKey: 'status', slotType: 'chart' },
    { id: 'priority', col: 'col-6', slotKey: 'priority', slotType: 'chart' },
  ],
};

const TABLE_ROW = {
  id: 'table_row',
  rowType: 'table',
  cols: [
    {
      id: 'dynamic_reports',
      col: 'col-12',
      slotKey: 'dynamic_reports',
      slotType: 'table',
    },
  ],
};

export const STANDARD_DASHBOARD_TEMPLATE = {
  id: STANDARD_DASHBOARD_TEMPLATE_ID,
  name: 'Standard design',
  description: 'KPI cards, trends, distribution charts, and reports table.',
  icon: 'fa-th-large',
  previewVariant: 'template_standard',
  rows: [KPI_ROW, TRENDS_ROW, DISTRIBUTION_ROW, TABLE_ROW],
};

export const DASHBOARD_TEMPLATES = [STANDARD_DASHBOARD_TEMPLATE];

export const DEFAULT_DASHBOARD_TEMPLATE_ID = STANDARD_DASHBOARD_TEMPLATE_ID;

export const DEFAULT_TEMPLATE_CHOOSER_ID = CUSTOM_DASHBOARD_TEMPLATE_ID;

export const getTemplateById = (id) => {
  if (id === STANDARD_DASHBOARD_TEMPLATE_ID) {
    return STANDARD_DASHBOARD_TEMPLATE;
  }
  return null;
};
